var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body"},[_c('main-page',{on:{"toRank":_vm.scrollToRank}}),_c('div',{ref:'rank'},[_c('rank',{staticClass:"rank"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }